import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getSpecialities = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/specialities', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getSpeciality = id => {
  return api.http.get(`/specialities/${id}`)
}

export const searchSpecialities = term => {
  return api.http.get('/specialities/select_search', {
    params: {
      term
    }
  })
}

export const getSelectSpecialities = (term, callback) => {
  searchSpecialities(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)

    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteSpeciality = id => {
  return api.http.delete(`/specialities/${id}`)
}

export const restoreSpeciality = id => {
  return api.http.put(`/specialities/${id}/restore`)
}

export const editSpeciality = speciality => {
  return api.http.put(`/specialities/${speciality._id}`, speciality)
}

export const addSpeciality = speciality => {
  return api.http.post('/specialities', speciality)
}



// WEBPACK FOOTER //
// ./src/api/specialities.js